import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, MonitorX, Wallet } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: <Clock className="w-6 h-6 text-lavender" data-id="element-187" />,
    title: 'Falta de Tiempo',
    desc: 'Empleos de 8 horas que te alejan de tus hijos y consumen tu energía.'
  }, {
    icon: <MonitorX className="w-6 h-6 text-lavender" data-id="element-188" />,
    title: 'Barrera Técnica',
    desc: 'Falta de habilidades técnicas en diseño gráfico o uso de software complejo.'
  }, {
    icon: <Wallet className="w-6 h-6 text-lavender" data-id="element-189" />,
    title: 'Costos Altos',
    desc: 'El costo impagable de materiales de arte tradicionales o inventario físico.'
  }];
  return <section className="py-16 md:py-24 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <FadeIn data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-darkText mb-6" data-id="element-193">
            La Realidad de Muchas Madres
          </h2>
          <p className="text-lg text-center text-lightText max-w-3xl mx-auto mb-16" data-id="element-194">
            Muchas madres hispanas en USA sienten la presión de querer aportar
            económicamente a su hogar, pero se enfrentan a obstáculos reales.
            Intentas buscar "cómo ganar dinero online" y solo encuentras estafas
            o negocios que requieren inventario físico y envíos costosos.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-195">
          {problems.map((prob, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-196">
              <div className="bg-white p-8 rounded-2xl shadow-card h-full border border-lavender/20 flex flex-col items-center text-center" data-id="element-197">
                <div className="w-14 h-14 bg-cream rounded-full flex items-center justify-center mb-6" data-id="element-198">
                  {prob.icon}
                </div>
                <h3 className="text-xl font-heading font-bold text-darkText mb-3" data-id="element-199">
                  {prob.title}
                </h3>
                <p className="text-lightText" data-id="element-200">{prob.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}